import React from "react";
import "assets/css/safexpay-web.css";
import "./Registration.css";

class ResetPassword extends React.Component {
  render() {
    return (
      <>
        <table
          border="0"
          cellPadding="0"
          cellSpacing="0"
          style={{
            border: "1px solid #d2d2d2",
            margin: "0 auto",
            fontFamily: "Verdana",
            fontSize: "16px",
            lineHeight: "25px",
          }}
          width="750px"
        >
          <tr>
            <td>
              <img
                src={require("assets/img/email/img-01.png")}
                alt="safexpay-img"
              />
            </td>
          </tr>
          <tr>
            <td>
              <img
                src={require("assets/img/email/img-04.png")}
                alt="safexpay-img"
              />
            </td>
          </tr>
          <tr>
            <td bgcolor="#dddedf">
              <table
                border="0"
                cellPadding="0"
                cellSpacing="0"
                bgcolor="#ffffff"
                style={{ margin: "0 auto" }}
                width="658px"
              >
                <tr>
                  <td
                    style={{
                      paddingLeft: "50px",
                      paddingRight: "50px",
                      fontFamily: "Verdana",
                      fontSize: "16px",
                      lineHeight: "25px",
                    }}
                  >
                    <br />
                    Hi Roshan Gupta,
                    <br />
                    <br />
                    We've received a request to reset your password.
                    <br />
                    If you didn't make the request just ignore this email.
                    <br />
                    Otherwise you can reset your password using the link below.
                    <br />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div
                      style={{
                        background: "#d7d8d9",
                        height: "1px",
                        marginTop: "20px",
                        marginBottom: "5px",
                        marginLeft: "50px",
                        marginRight: "50px",
                      }}
                    >
                      &nbsp;
                    </div>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      paddingLeft: "50px",
                      paddingRight: "50px",
                      fontFamily: "Verdana",
                      fontSize: "16px",
                      lineHeight: "25px",
                    }}
                  >
                    <br />
                    <strong>User ID : abc@gmail.com</strong>
                    <br />
                    <strong>Temporary Password : 12550</strong>
                    <br />
                    <br />

                    <a href="/signuplogin" style={{ textDecoration: "none" }}>
                      <img
                        src={require("assets/img/email/img-05.png")}
                        alt="safexpay-img"
                      />
                    </a>
                    <br />
                    <br />
                    <p>
                      <span>
                        Click or copy the below link incase the button do not
                        appear.
                      </span>
                      <br />
                      <a href="#" style={{ textDecoration: "underline" }}>
                        https://www.safexpay.com/signuplogin
                      </a>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div
                      style={{
                        background: "#d7d8d9",
                        height: "1px",
                        marginTop: "20px",
                        marginBottom: "10px",
                        marginLeft: "50px",
                        marginRight: "50px",
                      }}
                    >
                      &nbsp;
                    </div>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      paddingLeft: "50px",
                      paddingRight: "50px",
                      fontFamily: "Verdana",
                      fontSize: "16px",
                      lineHeight: "25px",
                    }}
                  >
                    <br />
                    Thank you for trusting us with your business.
                    <br />
                    <br />
                    -Team Safexpay.
                    <br />
                    <br />
                    <p
                      style={{
                        textAlign: "center",
                        fontFamily: "Verdana",
                        fontSize: "16px",
                        lineHeight: "25px",
                      }}
                    >
                      <a href="/support">Click here</a> to write to us for
                      support.
                    </p>
                    <br />
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td bgcolor="#dddedf">
              <br />
              <p style={{ textAlign: "center" }}>
                <a
                  href="https://twitter.com/safexpay?s=21"
                  style={{ textDecoration: "none" }}
                  target="_blank"
                >
                  <img
                    src={require("assets/img/email/tw.png")}
                    alt="safexpay-img"
                  />
                </a>
                <a
                  href="https://www.facebook.com/safexpay/"
                  style={{ textDecoration: "none" }}
                  target="_blank"
                >
                  <img
                    src={require("assets/img/email/fb.png")}
                    alt="safexpay-img"
                  />
                </a>
                <a
                  href="https://instagram.com/thesafexpay?utm_medium=copy_link"
                  style={{ textDecoration: "none" }}
                  target="_blank"
                >
                  <img
                    src={require("assets/img/email/ins.png")}
                    alt="safexpay-img"
                  />
                </a>
                <a
                  href="https://www.linkedin.com/company/safexpay"
                  style={{ textDecoration: "none" }}
                  target="_blank"
                >
                  <img
                    src={require("assets/img/email/link.png")}
                    alt="safexpay-img"
                  />
                </a>
              </p>

              {/* <p style={{ textAlign: 'center', fontSize: '14px' }}>
                                <strong> Questions?</strong><br />

Reply to this email or click on the given link.
<a href="/">Support.</a>

                            </p> */}
            </td>
          </tr>
        </table>
        <br />
        <br />
      </>
    );
  }
}

export default ResetPassword;
